import { LocationModel } from 'projects/core/src/lib/models/location.model';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import moment from 'moment';

interface ObserverLocation {
  observers: number;
  observers_gem: number;
}
interface ObserverDay {
  date: any;
  locations: { [key: number]: ObserverLocation }
}

@Component({
  selector: 'app-observer-list',
  templateUrl: './observer-list.component.html',
  styleUrls: ['./observer-list.component.scss']
})
export class ObserverListComponent implements OnInit, OnChanges {

  @Input() appointments: Array<any> = [];
  @Input() locations: Array<LocationModel> = [];

  public days: Array<ObserverDay> = [];

  constructor(
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    this.buildList();
  }

  private buildList() {
    const baseLocations: { [key: number]: ObserverLocation } = {};
    this.locations.forEach((location: LocationModel) => {
      baseLocations[location.id] = {
        observers: 0,
        observers_gem: 0
      };
    });
    const days: { [key: string]: ObserverDay } = {};
    this.appointments.forEach((appointment: any) => {
      const day: any = moment(appointment['day']);
      const key: string = day.format('YYYY-MM-DD');
      if (!days[key]) {
        days[key] = {
          date: day,
          locations: JSON.parse(JSON.stringify(baseLocations)) // {...baseLocations} @todo Verbessern!
        };
      }
      let locs = appointment.locations;
      if (locs === null) {
        locs = this.locations.map((location: LocationModel) => {
          return location.id;
        });
      }
      locs.forEach((loc: number) => {
        if (appointment.observer === true && days[key].locations[loc]) {
          days[key].locations[loc].observers += 1;
        }
        if (appointment.observer_gem === true && days[key].locations[loc]) {
          days[key].locations[loc].observers_gem += 1;
        }
      });
    });
    this.days = Object.values(days).sort((dayA: ObserverDay, dayB: ObserverDay) => {
      return (dayA.date > dayB.date) ? 1 : ((dayB.date > dayA.date) ? -1 : 0);
    });
  }

}
